import { convertBytesToMbsOrKbs } from '@components/ui/DropZone/helpers';

import type { FileRejection } from 'react-dropzone';

export const defaultGetDropRejectMessage = (
  rejectedFile: FileRejection,
  acceptFiles: string,
  maxFileSize: number,
) => {
  let message = `Файл ${rejectedFile.file.name} был отклонен.`;
  if (!acceptFiles.includes(rejectedFile.file.type)) {
    message += ' Данный тип файла не поддерживается.';
  }
  if (rejectedFile.file.size > maxFileSize) {
    message += ` Файл слишком большой. Максимальный размер файла - ${convertBytesToMbsOrKbs(
      maxFileSize,
    )}.`;
  }
  return message;
};
